"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetCurrentUser = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useGetCurrentUser() {
    const { data, isLoading, error, get } = (0, core_ui_1.useApiGet)('users/me');
    let currentUser = data;
    if (!core_ui_1.api.getAccessToken() || error) {
        // if no access token set cached user to null
        currentUser = null; // user == null (not logged in)
    }
    return { currentUser, isLoading, error, getCurrentUser: get };
}
exports.useGetCurrentUser = useGetCurrentUser;
//# sourceMappingURL=useGetCurrentUser.js.map